export const MODALITIES_ICONS: { [key: string]: string } = {
  'DRV': 'drive_eta',
  'TGO': 'takeout_dining',
  'BGR': 'fastfood',
  'BAL': 'fastfood',
  'DLV': 'delivery_dining',
} as const;

export type Modality = {
  icon: string;
  name: string;
  initialTime: string;
  endTime: string;
};
